<template>
  <!-- 课程16 -->
  <div class="lessonTen">
    <div class="web_content">
      <div class="title">第6章 AI的影响（16 关于预测未来 ）</div>
      <div class="content">
        我们对过去了解的越多，对未来的准备就越好。
        <br />在第 6 章中，我们将介绍以下部分。
      </div>
      <div class="content">
        一、
        <span  @click="jumpOne" style="color:#0090ff;cursor: pointer;" class="index">关于预测未来 （0/1）</span>
      </div>
      <div class="content">
        二、
        <span  @click="jumpTow" style="color:#0090ff;cursor: pointer;" class="index">人工智能的社会影响 （0/1）</span>
      </div>
      <div class="content">
        三、
        <span @click="jumpThree" style="color:#0090ff;cursor: pointer;" class="index">总结 （---）</span>
      </div>

      <div class="title-child" id="productId">第1节 关于预测未来</div>

      <div class="content">
        我们将首先解决众所周知的最棘手的问题之一：预测未来。
        您可能会听到“预测未来”而感到失望，我们并没有一个水晶球，能告诉我们未来的世界会是什么样子，AI将如何改变我们的生活。
      </div>

      <div class="title-child-bold">一、现实扭曲场</div>
      <div
        class="content"
      >作为科技人员，我们经常被要求提供预测，而我们拒绝提供任何预测都会面对一双令人膛目结舌的眼睛（“无聊的学者”）。但事实上，我们认为，任何声称知道AI的未来及其对我们社会的影响的人都应该受到质疑。</div>

      <img src="../assets/16-01.png" />

      <div
        class="content"
      >然而，并非所有人对自己的预测都那么保守。在当今世界，标题新闻盛行，您不得不将新闻内容分解，含蓄（没趣？）的消息丢失了，而简单、戏剧性的消息却被放大了，正所谓哗众取宠。在公众对AI的认识中，这种看法显然是真实存在的。</div>

      <div class="title-child-bold">1. 乐观性预测</div>

      <div
        class="content"
      >媒体领域被极端主导着。我们开始看到AI名人，他们鼓噪着一个伟大设想，并对AI的未来做出像甲骨文般的预测。媒体当然喜欢他们这种明确的信息。一些人向我们承诺，未来将是乌托邦式的，它将以指数式的增长，数万亿美元的产业将冒出来，真正的AI将解决我们自己无法解决的所有问题，人类根本不需要工作的场所。</div>

      <div class="title-child-bold">2. 悲观性预测</div>

      <div class="content">
        也有人声称，AI是一条通往世界统治的道路。另外一些人则做出了更加非凡的陈述，根据这些陈述，AI标志着人类的终结（从现在开始大约20至30年），生命本身将在“人工智能时代”中发生改变，AI是对我们生存的威胁。
        <br />尽管某些预测可能至少会正确地解决某些问题，但其他预测可能仅对证明预测的难易程度有用，而许多预测并没有多大意义。我们希望您能够看到这些预测和其他预测，并能够对其进行批判性的评估。
      </div>
      <div class="title-child-bold">3. 刺猬和狐狸</div>

      <div class="content">
        《超级预测：预测的艺术和科学》的作者、政治学家菲利普泰特洛克（Philip E.Tetlock），将人分为两类：有一个大想法的人（“刺猬”）和有许多小想法的人（“狐狸”）。泰特洛克在1984年至2003年之间进行了一项实验，研究可以帮助我们确定哪些预测可能准确而哪些预测不准确的因素。其中一项重要的发现是，狐狸的预测能力明显优于刺猬，尤其是在长期预测方面。
        <br />可以用长而大的标题表示的消息通常是大而简单的刺猬想法。我们的建议是要注意对这种消息进行仔细论证，重视信息来源，并对那些总是使用单一论点来解释一切的人持怀疑态度。
        <br />预测未来很困难，但至少我们可以考虑过去和现在的AI，通过了解它们，无论未来如何，都希望可以更好地为未来做好准备。
      </div>
      <div class="title-child-bold">二、AI的冬天</div>
      <div
        class="content"
      >就像许多其他科学领域一样，AI的历史见证了各种不同趋势的发生和发展。在科学哲学中，用于趋势的术语是范式。通常，大多数研究团体都采用特定的范式，并提供关于近期进展的乐观预测。例如，在1960年代，人们普遍认为神经网络通过模仿自然界（尤其是人脑）的学习机制能解决所有AI问题。接下来的大事是基于逻辑和人工编码规则的专家系统，这是1980年代的主流范式。</div>

      <img src="../assets/16-02.png" />

      <div class="title-child-bold">1. 炒作的周期</div>

      <div class="content">
        在每一波热潮的开始，一些早期的成功故事往往使每个人都感到高兴和乐观。成功的故事，即使它们可能只在有限的领域内成功，而在某些方面并不完整，却总能成为公众关注的焦点。许多研究人员，为了获得更多的研究经费而争先恐后使用AI，或者至少称其在研究AI。一些公司害怕错过（FOMO），于是也开始并扩大在AI方面的努力。
        <br />到目前为止，每当有人说出一种涵盖所有方面的通用AI解决方案时，最终进展都会遇到无法克服的大问题，而在当时这些问题只被认为是很小的麻烦。在1960年代的神经网络中，处理非线性的问题和解决与神经网络体系结构所需的参数数量不断增加相关的机器学习问题，遇到了瓶颈。而只1980年代的专家系统中，处理不确定性和常识问题，也遇到了拦路虎。经过多年的奋斗和未兑现的承诺之后，剩下的问题的真正本质就逐渐显现出来，人们对这种范式的悲观情绪累积起来，随之而来的就是AI的寒冬：对该领域的兴趣摇摇欲坠，研究工作被转向其他领域。
      </div>
      <div class="title-child-bold">2. 现代AI</div>

      <div class="content">
        大约自千年之交以来，AI再次崛起。现代AI方法倾向于将一个问题分解为多个较小的、孤立的和定义明确的问题，并一个一个地解决这些问题。现代AI绕开了关于智力、思维和意识含义的重大问题，而专注于在现实世界中构建实用的解决方案。对于我们所有能从这种解决方案中受益的人而言，是个好消息！
        <br />现代AI方法的另一个特点是能够处理不确定性，这一点与它在复杂而“杂乱”的现实世界中工作密切相关，我们在第3章中通过研究概率在AI中的应用证明了这一点。最后，由于神经网络和深度学习技术的回归，AI的上升趋势得到了极大的推动，这些技术能够比我们以前看到的任何东西都能更好地处理图像和其他真实世界的数据。
      </div>
      <div class="title-child-bold">3. 我们是否又沦入炒作周期？</div>
      <div
        class="content"
      >历史是否会重演，当前的繁荣是否会再次出现AI寒冬，这是一个只有时间才可以证明的问题。即便如此，朝着更好的解决方案迈进的步伐会停滞不前，AI在社会中的重要性仍将继续存在。多亏了人们对解决现实问题的有用解决方案的关注，现代AI研究已经在今天取得了成果，而不是首先尝试解决有关通用智能的大问题，这正是早期尝试失败的地方。</div>

      <div class="title-child-bold">三、几种预测</div>
      <div class="title-child-bold">预测1：AI将继续存在于我们身边</div>
      <div
        class="content"
      >您还记得，我们首先通过讨论影响我们生活的杰出AI应用程序来推动AI的研究。我们重点介绍了三个示例：自动驾驶汽车、推荐系统以及图像和视频处理。在课程中，我们还讨论了有助于持续进行技术转型的其他各种应用。</div>
      <div class="title-child-bold">【注意】AI与众不同</div>

      <div
        class="content"
      >由于专注于实用性而不是大问题，所以我们的生活被AI包围着（即使我们大部分时间可能并没有意识到这一点）：我们听的音乐，我们在网上) 购买的产品，我们观看的电影及其系列，我们的交通路线，甚至我们可获得的新闻和信息，都是越来越受到AI的影响。更重要的是，基本上任何科学领域，从医学和天体物理学到中世纪历史，都在采用人工智能方法，以加深我们对宇宙和我们自己的理解。</div>

      <div class="title-child-bold">预测2：终结者没有来临</div>

      <div class="content">
        与AI的未来有关的最普遍和持久的想法之一是终结者。也许你错过了一个残忍的人形机器人的形象，这个机器人有一个金属骨架和一双炯炯有神的眼睛……嗯，就是这样。《终结者》是詹姆斯·卡梅隆（James Cameron）1984年导演的一部电影。在影片中，一个名为天网的全球AI防御系统，意识到了它自身的存在，并通过核武器和先进的杀手机器人将大多数人类消灭了。
        <br />【注意】两种世界末日场景
        <br />有人提到两种世界末日场景：终结者；机器人起义。第一种，终结者。这是1984年电影中的故事，一个强大的AI系统变得有意识，并且非常不喜欢人类。
        <br />第二种，机器人起义。机器人大军由一个有智能但无意识的AI系统所控制，这个系统原本是由人类控制的。例如，人类可以对系统进行编程，以优化纸夹的生产，等等。听起来很无辜，不是吗？
        <br />但是，如果这个系统具有卓越的智能，它将很快达到纸夹生产的最高水平，而这种纸夹的生产是可用资源（例如能源和原材料）所允许的。在此之后，可能会得出这样的结论，它需要将更多资源重定向到纸夹生产。为此，可能需要阻止将这些资源用于其他目的，即使它们对于人类文明至关重要。要做到这一点，最简单的方法是杀死所有人，然后大量资源就可以用于该系统的主要任务（纸夹生产）了。
      </div>

      <div class="title-child-bold">四、为什么这些情况不现实</div>

      <div class="content">上述两种情况都极不可能发生，都属于科幻小说，而且都不是对AI未来的认真推测，原因有很多。</div>

      <div class="title-child-bold">原因1</div>

      <div class="content">
        首先，一种超智能的，有意识的，能胜过人类的AI的出现，是开发AI方法的意外结果的想法，是幼稚的。正如您在前几章中所看到的，AI方法不过是一种自动推理，基于完全可理解的原理和大量输入数据的组合，这两种方法都是由人或由人部署的系统所提供的。想象一下，最接近邻分类器、线性回归、AlphaGo游戏引擎，甚至是一个深层神经网络，可能会变得有意识，并开始发展为一个超级智能的AI思维，需要（非常）生动的想象力。
        <br />请注意，我们并不是断言绝对不可能建立人类水平的智能。您只需要注视镜子，即可看到一个高度智能的物理系统的可能性。重复我们所说的话：开发狭义的AI方法并将其应用于解决现实世界的问题，不会出现超级智能（请从第1章关于AI哲学的章节中回顾狭义AI与通用AI）。
      </div>

      <div class="title-child-bold">原因2</div>

      <div class="content">
        其次，那些相信超智能AI的人最喜欢的想法之一就是所谓的奇点：一种系统，可以对自身进行优化和“重组”，从而可以以不断加快的指数速度提高自身的智能。如此超凡的智能将人类远远抛在后面，以至于我们变得像蚂蚁一样可以毫不犹豫地被消灭。指数智能增长的想法是不现实的，原因很简单，即使一个系统可以优化其自身的运行，它也将继续面临越来越多的难题，这些难题会减慢其发展速度，就像人类科学家的进步，需要整个研究界乃至整个社会付出更大努力和资源，而这个超级智能的实体却是无法获得的。人类社会仍然有权决定我们使用什么技术，甚至什么样的AI技术。这种力量很大程度上确实是由技术赋予我们的，所以每当我们在人工智能技术上取得进步时，我们就会变得更加强大，更善于控制由此带来的任何潜在风险。
        <br />【注意】价值取向问题
        <br />纸夹示例被称为价值取向问题：指定系统目标以使其与我们的价值观保持一致非常困难。但是，假设我们创建了一个超级智能系统，可以击败试图干扰其工作的人类。可以合理地假设这样的系统也足够智能，以至于意识到当我们说“给我做纸夹”的指令时，我们并不是真的要把地球变成一个具有行星规模的纸夹工厂。
        <br />将故事与现实分开
        <br />总而言之，《终结者》是一个很好的电影故事，但几乎一个真正值得惊慌的问题。《终结者》是一个噱头，是一个容易吸引很多注意力的方法，是记者提高点击率的海报男孩，是一个转移注意力的红鲱鱼，也许能使人们摆脱无聊而又真实的威胁，例如核武器、缺乏民主、环境灾难和气候变化。实际上，《终结者》所构成的真正威胁是转移了人们对实际问题的注意力，其中一些问题涉及AI，而许多问题则没有。我们将在后面讨论AI带来的问题，但最重要的是：忘记终结者，还有很多更重要的事情需要关注。
      </div>

      <div class="title-child-bold">【知识巩固】</div>
      <div class="title-child-bold">练习23：对AI的看法是什么？</div>
      <div class="content">
        对于本练习，我们希望您考虑如何描述AI。在线搜索“AI”一词，看看会出现什么样的图片。如果您使用的是Google搜索，则应在屏幕顶部选择“图像”。
        <br />您从图像搜索结果中对AI的总体印象是什么？这是AI的准确表示吗？为什么或者为什么不？
        <br />您的答案应至少为40个字
        <br />
      </div>
<div class="content" style="textAlign:center;">你的答案:<input type="text" class="anwserInput" :disabled="contenteditable"></div>

            <button class="sentBtn" style="marginLeft:290px;" @click="sentBtnOne">提交</button>


    </div>

      <div class="backBtn" style="margin:20px auto;textAlign:center;">
        <button @click="goBlank" style="cursor: pointer;">上一页</button>
        <button @click="goMune"  style="marginLeft:15px;marginRight:15px;cursor: pointer;">返回目录页</button>
        <button @click="NextClk" style="cursor: pointer;">下一页</button>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      textarea: "",
      contenteditable:false,
    };
  },
  created() {},
  computed: {},
  components: {},
  mounted() {},
  methods: {
      sentBtnOne(){
      this.contenteditable = true;
    },
 jumpOne(){
      const returnEle = document.querySelector("#productId");  //productId是将要跳转区域的id
        if (!!returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
        document.querySelector("counter1").scrollIntoView(true); //这里的counter1是将要返回地方的id
    },
      
    jumpTow(){
       this.$router.push('/lessonSeventeen');
       
    },
   
    jumpThree(){
      this.$router.push('/lessonEighteen');
    },
   
    
    goBlank(){
      this.$router.push('/lessonFifteen');
    },
    goMune(){
      this.$router.push('/');
    },
    NextClk(){
      this.$router.push('/lessonSeventeen');
    },
  },
};
</script>

<style scoped>
.lessonTen {
  width: 100%;
}
.web_content {
  width: 650px;
  margin: 0 auto;
  padding: 0px 75px;
  background: #fff;
}
.title {
  font-size: 22px;
  color: #000;
  font-weight: bold;
  margin-top: 50px;
}
.content {
  text-indent: 2em;
  font-size: 16px;
  line-height: 35px;
}
.index {
  font-size: 16px;
  color: #0090ff;
  line-height: 15px;
}
.title-child {
  font-size: 22px;
  color: #000;
  margin-top: 30px;
}
.title-child-bold {
  font-size: 16px;
  color: #000;
  margin-top: 30px;

  font-weight: bold;
}

.content-red {
  color: #f15a23;
  font-size: 16px;
  line-height: 35px;
  text-indent: 2em;
}
.content-imgtext {
  margin-left: 40%;
}
.sentBtn{
  width: 100px;
  margin-left: 240px;
  margin-top: 25px;
  margin-bottom: 25px;
  cursor: pointer;
}
.backBtn button{
  width: 100px;
}
</style>

















// WEBPACK FOOTER //
// src/components/lessonSixteen.vue